import { Currency } from 'common/utils/currency';

interface StepSpec {
    max: number;
    step: number;
}

const STEPS_CURRENCY: { [currency in Currency]: StepSpec[] } = {
    [Currency.AUD]: [
        { max: 500, step: 20 },
        { max: 1000, step: 50 },
        { max: 2000, step: 100 },
        { max: 5000, step: 300 },
    ],
    [Currency.CAD]: [
        { max: 500, step: 20 },
        { max: 1000, step: 50 },
        { max: 2000, step: 100 },
        { max: 5000, step: 300 },
    ],
    [Currency.CHF]: [
        { max: 500, step: 20 },
        { max: 1000, step: 50 },
        { max: 2000, step: 100 },
        { max: 5000, step: 300 },
    ],
    [Currency.DKK]: [
        { max: 3000, step: 100 },
        { max: 6000, step: 250 },
        { max: 12000, step: 500 },
        { max: 30000, step: 2000 },
    ],
    [Currency.EUR]: [
        { max: 400, step: 20 },
        { max: 800, step: 50 },
        { max: 1600, step: 100 },
        { max: 4000, step: 300 },
    ],
    [Currency.GBP]: [
        { max: 350, step: 25 },
        { max: 700, step: 50 },
        { max: 1400, step: 100 },
        { max: 3500, step: 300 },
    ],
    [Currency.HKD]: [
        { max: 4000, step: 150 },
        { max: 8000, step: 500 },
        { max: 16000, step: 800 },
        { max: 40000, step: 2400 },
    ],
    [Currency.JPY]: [
        { max: 5000, step: 200 },
        { max: 10000, step: 500 },
        { max: 20000, step: 1000 },
        { max: 50000, step: 3000 },
    ],
    [Currency.MXN]: [
        { max: 10000, step: 400 },
        { max: 20000, step: 1000 },
        { max: 40000, step: 2000 },
        { max: 100000, step: 6000 },
    ],
    [Currency.NOK]: [
        { max: 4000, step: 150 },
        { max: 8000, step: 500 },
        { max: 16000, step: 800 },
        { max: 40000, step: 2400 },
    ],
    [Currency.SGD]: [
        { max: 500, step: 20 },
        { max: 1000, step: 50 },
        { max: 2000, step: 100 },
        { max: 5000, step: 300 },
    ],
    [Currency.USD]: [
        { max: 500, step: 20 },
        { max: 1000, step: 50 },
        { max: 2000, step: 100 },
        { max: 5000, step: 300 },
    ],
};

export const generateStepMapping = (steps: StepSpec[]): number[] => {
    const stepMapping: number[] = [];
    let currentMax = 0;
    steps.map(({ max, step }) => {
        for (let i = currentMax; i < max; i += step) {
            stepMapping.push(i);
        }
        currentMax = max;
    });
    stepMapping.push(currentMax);
    return stepMapping;
};

const getBudgetStepsForCurrency = (currency: Currency): number[] =>
    generateStepMapping(STEPS_CURRENCY[currency]);
export default getBudgetStepsForCurrency;
